module.exports = __webpack_public_path__ + "static/media/tax-banner-img.8000401d.png";